import { render } from "./GuardianConsentDialog.vue?vue&type=template&id=01bedefd&scoped=true"
import script from "./GuardianConsentDialog.vue?vue&type=script&lang=js"
export * from "./GuardianConsentDialog.vue?vue&type=script&lang=js"

import "./GuardianConsentDialog.vue?vue&type=style&index=0&id=01bedefd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bedefd"]])

export default __exports__